import React from "react";
import HeaderMain from "./HeaderMain";
import HeaderTop from "./HeaderTop";

const Header = () => {
    return (
        <header>
            <HeaderTop></HeaderTop>
            <HeaderMain></HeaderMain>
        </header>
    );
};

export default Header;
